import { postApiRequest } from '../../../../features/axiosClient';
import { SAVE_SLATE_DATA_API_URL } from '../../../../constants/ApiUrlConstants';
import { call, put, takeEvery } from 'redux-saga/effects';
import { saveSlateDataFailure, saveSlateDataSuccess, updateLastSavedTime } from '../actions/saveSlateDataActions';
import { SAVE_SLATE_DATA_REQUEST } from '../../../../constants/ActionNameConstants';
import { updateSlateIsDirty } from '../actions/slateDataActions';

const saveSlateDataApi = (action) => postApiRequest(SAVE_SLATE_DATA_API_URL, action);

function* saveSlateDataSaga(action) {
  try {
    const payload = action.payload;
    const transcriptData = (JSON.parse(action.payload?.transcriptJSON)?.data || [])?.map((i) => ({
      children: i.children || [],
      comments: i.comments || {},
      completed: i.completed || false,
      examination: i.examination || null,
      id: i.id || '',
      speaker: i.speaker,
      type: i.type,
    }));
    const response = yield call(saveSlateDataApi, {
      audioFileId: payload.audioFileId,
      transcriptJSON: JSON.stringify({ data: transcriptData }),
    });
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      yield put(saveSlateDataFailure(response?.data?.errorMessage));
    }
    yield put(saveSlateDataSuccess(response.data.value));
    yield put(updateLastSavedTime(Date.now()));
    yield put(updateSlateIsDirty(false));
  } catch (error) {
    yield put(saveSlateDataFailure(error.message));
  }
}

export function* watchSaveSlateData() {
  yield takeEvery(SAVE_SLATE_DATA_REQUEST, saveSlateDataSaga);
}
